import script from "./BaseOTP.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseOTP.vue?vue&type=script&setup=true&lang=js"

import "./BaseOTP.vue?vue&type=style&index=0&id=ff4a7998&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff4a7998"]])

export default __exports__